module.exports = __webpack_public_path__ + "static/media/EmptyCartImg.afa6a28d.png";